export const DEFAULT_DIMENSIONS = {
    MOBILE: {
        WIDTH: 547,
        HEIGHT: 960,
    },
    DESKTOP: {
        WIDTH: 1568,
        HEIGHT: 886,
    },
    TABLET: {
        WIDTH: 968,
        HEIGHT: 1299,
    },
};
export const DEVICES = {
    DESKTOP: [],
    MOBILE: [
        {
            name: 'Custom',
            width: 547,
            height: 960,
            userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 10_0 like Mac OS X) AppleWebKit/602.1.38 (KHTML, like Gecko) Version/10.0 Mobile/14A5297c Safari/602.1',
            isCustom: true,
        },
        {
            name: 'iPhone X',
            width: 375,
            height: 812,
            userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_0 like Mac OS X) AppleWebKit/604.1.38 (KHTML, like Gecko) Version/11.0 Mobile/15A372 Safari/604.1',
        },
        {
            name: 'iPhone 6/7/8 Plus',
            width: 414,
            height: 736,
            userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_0 like Mac OS X) AppleWebKit/604.1.38 (KHTML, like Gecko) Version/11.0 Mobile/15A5370a Safari/604.1',
        },
        {
            name: 'iPhone 6/7/8',
            width: 375,
            height: 667,
            userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 11_0 like Mac OS X) AppleWebKit/604.1.34 (KHTML, like Gecko) Version/11.0 Mobile/15A5341f Safari/604.1',
        },
        {
            name: 'iPhone 5/SE',
            width: 320,
            height: 568,
            userAgent: 'Mozilla/5.0 (iPhone; CPU iPhone OS 5_1_1 like Mac OS X) AppleWebKit/534.46 (KHTML, like Gecko) Version/5.1 Mobile/9B208 Safari/7534.48.3',
        },
        {
            name: 'Samsung Galaxy S7',
            width: 360,
            height: 640,
            userAgent: 'Mozilla/5.0 (Linux; Android 6.0.1; SM-G900R4 Build/MMB29M; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/55.0.2883.91 Mobile Safari/537.36',
        },
        {
            name: 'Samsung Galaxy S8',
            width: 360,
            height: 740,
            userAgent: 'Mozilla/5.0 (Linux; Android 7.0; SAMSUNG SM-G950F Build/NRD90M) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/5.2 Chrome/51.0.2704.106 Mobile Safari/537.36',
        },
        {
            name: 'Nexus 6P',
            width: 412,
            height: 732,
            userAgent: 'Mozilla/5.0 (Linux; Android 6.0.1; Nexus 6P Build/MMB29P) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/47.0.2526.83 Mobile Safari/537.36',
        },
        {
            name: 'LG G5, Samsung Galaxy Note 5',
            width: 480,
            height: 853,
            userAgent: 'Mozilla/5.0 (Linux; Android 6.0.1; SAMSUNG SM-N920T Build/MMB29K) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/4.0 Chrome/44.0.2403.133 Mobile Safari/537.36',
        },
    ],
    TABLET: [
        {
            name: 'iPad',
            width: 768,
            height: 1024,
            userAgent: 'Mozilla/5.0 (iPad; U; CPU OS 4_3_5 like Mac OS X; en) AppleWebKit/533.17.9 (KHTML, like Gecko) Version/5.0.2 Mobile/8L1 Safari/6533.18.5',
        },
        {
            name: 'iPad Pro',
            width: 768,
            height: 1024,
            userAgent: 'Mozilla/5.0 (iPad; CPU OS 12_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Mobile/16B92',
        },
    ],
};
//# sourceMappingURL=devices.js.map